/**
 * Google Maps Configuration
 *
 * Required APIs in Google Cloud Console:
 * - Maps JavaScript API
 * - Geocoding API
 */

export const GOOGLE_MAPS_CONFIG = {
  apiKey: process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY || 'AIzaSyCdFGHSm2PGHB5ZNDC6uPxzYGHACCwlcbQ',
  defaultCenter: { 
    lat: 39.3999, 
    lng: -8.2245 
  }, // Portugal
  defaultZoom: 7,
  libraries: [] as const,
  mapOptions: {
    styles: [],
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true,
  },
};

// Map styles for dark/light modes
export const MAP_STYLES = {
  light: [],
  dark: [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }],
    },
  ],
};

// Geofence drawing options
export const GEOFENCE_DRAWING_OPTIONS = {
  circle: {
    fillColor: '#2196F3',
    fillOpacity: 0.2,
    strokeColor: '#2196F3',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    clickable: false,
    editable: true,
    draggable: true,
    zIndex: 1,
  },
  polygon: {
    fillColor: '#2196F3',
    fillOpacity: 0.2,
    strokeColor: '#2196F3',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    clickable: false,
    editable: true,
    draggable: true,
    zIndex: 1,
  },
};

// Marker icons for vehicles
export const VEHICLE_MARKER_ICONS = {
  online: {
    url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNCIgZmlsbD0iIzM0Qzc1OSIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNMTYgOEw4IDE4SDE0TDE0IDI0TDI0IDE0SDE4TDE2IDhaIiBmaWxsPSIjRkZGIi8+PC9zdmc+',
    scaledSize: { width: 32, height: 32 },
    anchor: { x: 16, y: 16 },
  },
  offline: {
    url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNCIgZmlsbD0iIzhFOEU5MyIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNMTYgOEw4IDE4SDE0TDE0IDI0TDI0IDE0SDE4TDE2IDhaIiBmaWxsPSIjRkZGIi8+PC9zdmc+',
    scaledSize: { width: 32, height: 32 },
    anchor: { x: 16, y: 16 },
  },
  warning: {
    url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNCIgZmlsbD0iI0ZGOTUwMCIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNMTYgOEw4IDE4SDE0TDE0IDI0TDI0IDE0SDE4TDE2IDhaIiBmaWxsPSIjRkZGIi8+PC9zdmc+',
    scaledSize: { width: 32, height: 32 },
    anchor: { x: 16, y: 16 },
  },
};
